import { ReactElement } from 'react';
import { styled } from 'styled-components';
import { blockStyle } from './styles/Block';
import layoutStyle from './styles/Layout';

interface Props {
  header: ReactElement;
  content: ReactElement;
}

const MainBlock = styled.article`
  ${blockStyle}
  background: #fafafa;
`;

const MainLayout = styled.div`
  ${layoutStyle}
  padding: 32px 32px;
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 32px;
`;

const MainContent = ({ header, content }: Props): ReactElement => (
  <MainBlock>
    <MainLayout>
      {header}
      {content}
    </MainLayout>
  </MainBlock>
);

export default MainContent;
